/* Conmutador de columnas de la coleccion (2 / 3).

   En vez de pelearse con las anchuras de Dawn, intercambia las propias clases
   del tema (grid--N-col-desktop), que ya estan probadas.
   La preferencia se recuerda en el navegador. */

if (!customElements.get('view-switch')) {
  customElements.define(
    'view-switch',
    class ViewSwitch extends HTMLElement {
      connectedCallback() {
        this.grid = document.getElementById('product-grid');
        if (!this.grid) return;

        this.buttons = Array.from(this.querySelectorAll('.view-switch__btn'));
        this.key = 'cs:collection-view';
        this.cols = ['1', '2', '3', '4', '5'];

        this.apply(this.saved() || this.dataset.default || '3', false);

        this.buttons.forEach(
          function (btn) {
            btn.addEventListener(
              'click',
              function () {
                this.apply(btn.dataset.view, true);
              }.bind(this)
            );
          }.bind(this)
        );
      }

      saved() {
        try {
          return window.localStorage.getItem(this.key);
        } catch (e) {
          return null;
        }
      }

      remember(view) {
        try {
          window.localStorage.setItem(this.key, view);
        } catch (e) {
          /* modo privado o almacenamiento bloqueado: seguimos sin recordar */
        }
      }

      apply(view, persist) {
        if (['2', '3'].indexOf(view) === -1) view = '3';

        var cambiar = function () {
          // Fuera cualquier clase de columnas de escritorio que traiga Dawn.
          this.cols.forEach(
            function (n) {
              this.grid.classList.remove('grid--' + n + '-col-desktop');
            }.bind(this)
          );

          this.grid.classList.add('grid--' + view + '-col-desktop');

          this.grid.dataset.view = view;
          this.buttons.forEach(function (b) {
            b.setAttribute('aria-pressed', b.dataset.view === view ? 'true' : 'false');
          });
        }.bind(this);

        // Con la sala encendida, las tarjetas VIAJAN a su nuevo sitio en vez
        // de saltar (FLIP, ver assets/cs-sala.js). Solo cuando lo pide una
        // persona: en la primera carga, `persist` es falso y no hay nada que
        // animar porque no se venía de ninguna parte.
        var recolocar = persist && window.csSala && window.csSala.recolocar;
        if (recolocar) {
          window.csSala.recolocar(this.grid, cambiar);
        } else {
          cambiar();
        }

        if (persist) this.remember(view);
      }
    }
  );
}
